import { TRANSITION_END } from 'mlmi-library/utils/animation';
import Navigation from './Navigation';
import Scrollbar from 'mlmi-library/components/scrollbar/v1/scrollbar';

export default function () {

  var obj = this;

  /* Global website objects */
  const layers = $('.layer');
  const wrapper = $('.wrapper');
  const transition = $('.transition').Transition();

  /* Navigation flags */
  this.contentLoaded = false;
  this.transitionDone = false;
  this.projectDone = false;
  this.timeout1 = undefined;
  this.timeout2 = undefined;
  this.isPopping = false;

  /* Scrollbars */
  let scrollbars = new Scrollbar('.layer__content, .layer__child .details');

  /* Layers system */
  $('.layer__header').on('click', function(e)
  {
    // Reset state flags
    obj.contentLoaded = false;
    obj.transitionDone = false;
    layers.removeClass('will-appear will-animate appear');
    clearTimeout(obj.timeout1);
    clearTimeout(obj.timeout2);

    // Select clicked layer
    let layerHeader = $(this),
    targetLayer = layerHeader.closest('.layer'),
    targetContent = targetLayer.find('.content'),
    previousLayer = $('.layer--current');

    // Accept clicks in new tab but not current layer clicks
    if (e != undefined && e.originalEvent != undefined && (e.originalEvent.cmdKey || e.originalEvent.metaKey)) { return true; }
    if (targetLayer.hasClass('layer--current') && !targetLayer.hasClass('layer--parent')) { return false; }

    // Is parent layer: remove child content
    if (targetLayer.hasClass('layer--current') && targetLayer.hasClass('layer--parent')) {
      obj.removeChildContent();
      return false;
    }

    // Pause current players
    $('.vimeo-player iframe').each(function() {
      if ($(this).data('vimeo-player')) {
        let vimeoPlayer = $(this).data('vimeo-player');
        vimeoPlayer.pause();
      }
    });

    // Load next layer content
    if (layerHeader.attr('href') == targetContent.data('permalink')) {
      targetContent.addClass('will-appear');
      obj.timeout1 = setTimeout(function() {
        targetContent.addClass('will-animate');
        obj.timeout2 = setTimeout(function() {
          document.title = targetContent.data('title');
          if (!navigation.isPopping && !obj.isPopping) {
            let isProject = $(".layer--current .project-content").length > 0;
            window.history.pushState({
              isPageTransition: true,
              previousPageURL: window.location.href,
              currentLayer: $('.layer--current .layer__header').data("section"),
              isProject: isProject,
              projectColor: isProject ? $(".layer--current project-content").data("color") : false,
            }, document.title, layerHeader.attr('href'));
            obj.isPopping = false
          }
          targetContent.addClass('appear').on(TRANSITION_END, function() {
            targetContent.off(TRANSITION_END);
            setTimeout(function() {
              targetContent.removeClass('will-appear will-animate appear');
            }, 1000);
          });
        }, 100);
      }, 100);
    } else {
      navigation.getPage(layerHeader.attr('href'));
    }

    // Animate layer
    previousLayer.trigger('closing-start');
    layers.addClass('will-change');
    setTimeout(function() {
      previousLayer.removeClass('layer--current');
      wrapper.removeClass('section--home section--projects section--infos').addClass('section--' + layerHeader.data('section'));
      targetLayer.addClass('layer--current').on(TRANSITION_END, function() {
        scrollbars.update();
        targetLayer.off(TRANSITION_END);
        layers.removeClass('will-change');
        previousLayer.find('.content').removeClass('will-appear will-animate appear').trigger('closing-end');
        obj.transitionDone = true;
        previousLayer.removeClass('layer--parent').find('.layer__child').remove();
        if (obj.contentLoaded && obj.transitionDone) {
          obj.contentLoaded = false;
          obj.transitionDone = false;
          obj.replaceLayerContent();
        }
      });
    }, 60);
    return false;
  });

  /* Click on a single title */
  $(document).on('click', '.single-project-link', function() {
    // pause vimeo player if going from one project to the other
    let currentContent = $('.layer__child'),
    oldVimeoPlayer = currentContent.find('.vimeo-player iframe').data("vimeo-player");
    if (oldVimeoPlayer) { oldVimeoPlayer.pause(); }

    // start transition
    transition.start($(this));
    $('.dynamic-content .details').remove();
    obj.projectDone = true;
    return false;
  });

  /* Page loaded */
  $(window).on('page_load', function() {
    obj.contentLoaded = true;
    if (obj.contentLoaded && obj.projectDone) {
      obj.contentLoaded = false;
      obj.projectDone = false;
      transition.content_ready(obj);
    } else if (obj.contentLoaded && obj.transitionDone) {
      obj.contentLoaded = false;
      obj.transitionDone = false;
      obj.replaceLayerContent();
    }
  });

  /* Replace content */
  this.replaceLayerContent = function() {
    let newContent = $('.dynamic-content .content').last().clone().addClass('will-appear');
    $('.layer--current .scroller').empty();
    setTimeout(function() {
      $('.layer--current .scroller').append(newContent.addClass('will-animate'));
      $(window).trigger('page_load_layers');
      setTimeout(function() {
        scrollbars.update();
        newContent.addClass('appear').on(TRANSITION_END, function() {
          $(this).off(TRANSITION_END);
        });
      }, 60);
    }, 60);
  };

  /* Display child content */
  this.displayChildContent = function() {
    let oldContent = $('.layer__child'),
    oldVimeoPlayer = oldContent.find('.vimeo-player iframe').data("vimeo-player"),
    newContent = $('<div class="layer__child">').append($('.dynamic-content .details').first().clone());
    if (oldVimeoPlayer) { oldVimeoPlayer.pause(); }
    $('.layer--current').addClass('layer--parent');
    $('.layer--current .layer__sizer').append(newContent);
    setTimeout(function() {
      new Scrollbar('.layer__child .details');
      $('.layer__flash').remove();
      oldContent.remove();
      $(window).trigger('page_load_layers');
    }, 60);
  };

  /* Remove child content */
  this.removeChildContent = function() {
    let targetChild = $('.layer__child'),
    targetLayer = targetChild.closest('.layer'),
    targetHeader = targetLayer.find('.layer__header'),
    targetContent = targetLayer.find('.content'),
    targetVimeoPlayer = targetChild.find('.vimeo-player iframe').data("vimeo-player"),
    targetTransition = $('<div class="layer__flash">').addClass('will-appear');
    if (targetVimeoPlayer) { targetVimeoPlayer.pause(); }
    $('.layer--current').append(targetTransition).removeClass('layer--parent');
    setTimeout(function() {
      targetTransition.addClass('appear').on(TRANSITION_END, function() {
        $(this).off(TRANSITION_END);
        targetChild.remove();
        setTimeout(function() {
          scrollbars.update();
          targetTransition.addClass('disappear').on(TRANSITION_END, function() {
            $(this).off(TRANSITION_END).remove();
          });
          document.title = targetContent.data('title');
          if (!navigation.isPopping && !obj.isPopping) {
            let isProject = $(".layer--current project-content").length > 0;
            window.history.pushState({
              isPageTransition: true,
              previousPageURL: window.location.href,
              currentLayer: $('.layer--current .layer__header').data("section"),
              isProject: isProject,
              projectColor: isProject ? $(".layer--current project-content").data("color") : false,
            }, document.title, targetHeader.attr('href'));
            obj.isPopping = false;
          }
        }, 150);
      });
    }, 60);
  };

  /* Pop state (back) */
  $(window).on("popstate", function(e) {
    obj.isPopping = true;
    let popState = e.originalEvent.state;
    if (popState != null) {
      if (popState.isPageTransition != null && popState.isPageTransition == true) {
        if (popState.isProject == true && popState.currentLayer != undefined) {
          // pause vimeo player if going from one project to the other
          let currentContent = $('.layer__child'),
          oldVimeoPlayer = currentContent.find('.vimeo-player iframe').data("vimeo-player");
          if (oldVimeoPlayer) { oldVimeoPlayer.pause(); }

          // change layer or not?
          let previousLayer = $('.layer__header[data-section="' + popState.currentLayer +'"]').get(0),
          currentLayer = $('.layer--current .layer__header').get(0);
          if (previousLayer == currentLayer){
            var link = $('<a>').attr('href', popState.previousPageURL).attr('data-color', popState.projectColor);
            transition.start(link);
            $('.dynamic-content .details').remove();
            obj.projectDone = true;
          } else {
            $('.layer__header[data-section="' + popState.currentLayer +'"]').trigger("click");
            setTimeout(function() {
              var link = $('<a>').attr('href', popState.previousPageURL).attr('data-color', popState.projectColor);
              transition.start(link);
              $('.dynamic-content .details').remove();
              obj.projectDone = true;
            }, 250);
          }
        }
      }
    }
  });

  /* Navigation */
  const navigation = new Navigation({
    useTransition: false,
    selectors: {
      pageContent: '.layer .content, .layer .details',
      pageTarget: '.dynamic-content .content',
    },
  });
}
